<template>
    <b-card class="text-left mb-1">
        <template v-slot:header>
            <router-link :to="{ name: 'Profilo', params: { codFisc: commento.codFisc } }" class="text-decoration-none">
                <img :src="imgLink" width="25" />&nbsp;&nbsp;
                <b class="text-uppercase">{{commento.avvocato}}</b>
            </router-link>
        </template>
        <b-card-body class="text-center p-2" v-if="showTitoloSentenza">
          <router-link :to="{ name: 'Massima', params: { idMassima: commento.id } }" class="text-decoration-none">
            <b>{{commento.sentenzaTitolo}}</b>
          </router-link>
          <br/>
          <b>Materia: {{commento.sentenzaMateria}}</b><br/>
          <b>Sottomateria: {{commento.sentenzaSottoMateria}}</b>          
        </b-card-body>

        <div class="text-justify" v-html="commento.premassima"></div>

        <b-button :to="{ name: 'Massima', params: { idMassima: commento.id } }" variant="outline-secondary" size="sm">
          Leggi la versione estesa...
        </b-button>
        <small class="text-muted float-right">Pubblicato il {{data}}</small>

        <template v-slot:footer>
            <b-row>
                <b-col cols="12">
                    <small class="text-muted" v-if="commento.numeroLike > 0">
                      Piace a {{commento.numeroLike}} persone
                    </small>
                    <small class="text-muted" v-if="commento.numeroLike > 0 && showVisualizzazioni">
                       - 
                    </small>
                    <small class="text-muted" v-if="showVisualizzazioni">
                      Visualizzato da {{commento.numeroVisualizzazioni}} persone
                    </small>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-button variant="light" style="width: 100%" @click.prepend="mettiLike(commento.id)" v-bind:class="{ 'text-primary': commento.like }">
                        <font-awesome-icon icon="thumbs-up" />
                        Mi piace
                    </b-button>
                </b-col>
                <b-col cols="6" v-if="showCommenta">
                    <b-button :to="{ name: 'Sentenza', params: { idNodo: commento.sentenzaId } }" variant="light" style="width: 100%">
                        <font-awesome-icon icon="comment" />
                        Commenta
                    </b-button>
                </b-col>
            </b-row>
        </template>
    </b-card>
</template>

<script>
import service from '../../services/service.js';
import utils from '../../services/utils.js';

export default {
  data () {
    return {
      commento: {},
      imgLink: '',
      data: '',
      testo: ''
    }
  },
  props: {
    input: {
      id: Number,
      codFisc: String,
      avvocato: String,
      testo: String,
      premassima: String,
      dataInserimento: String,
      numeroLike: Number,
      like: Boolean,
      sentenzaId: String,
      sentenzaTitolo: String,
      sentenzaMateria: String,
      numeroVisualizzazioni: Number
    },
    showCommenta: Boolean,
    showTitoloSentenza: Boolean,
    showVisualizzazioni: Boolean
  },
  methods: {
    mettiLike(){
      let url = 'commento/' + this.commento.id + '/like';
      service.execute('post', url).then((data) => {
          this.getCommento();
      });
    },
    getCommento(){
      let url = 'commento/id/' + this.commento.id;
      service.execute('get', url).then((data) => {
          this.commento = data;
      });
    }
  },
  created() {
    this.commento = this.input;

    this.imgLink = utils.getAvatarUrl(this.input.codFisc);
    this.data = utils.formatDate(new Date(this.input.dataInserimento));
    this.testo = utils.cleanHtml(this.input.testo);
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Sentenza/Commento.vue